<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
  .home{
    /*width: 1200px;*/
    /*margin: 0 auto;*/
    background-image: url("../assets/img/homebg.png");
    background-repeat: no-repeat;
    width: 100%;
    background-color: #1c1c1c;
  }
  .home .banner{
    height: 1115px;
    background:url('../assets/img/topBaner.png')no-repeat top center;
    width: 100%;
    overflow: hidden;
  }
  .home .banner .nav{
    background:url('../assets/img/navbg.png')no-repeat;
    width: 1530px;
    height: 110px;
    margin: 0 auto;
    margin-top: 740px;
  }
  .home .banner .nav img{
    float: left;
    margin-left: 160px;
    margin-top: 35px;
  }
  .home .banner .nav ul{
    float: left;
    overflow: hidden;
    margin-left: 50px;
  }
  .home .banner .nav ul li{
    float: left;
    /*margin-right: 40px;*/
    width: 120px;
    text-align: center;
    line-height: 110px;
    color: #ebbfbf;
    font-size: 16px;
    font-weight: 900;
    cursor: pointer;
    position: relative;
  }
  .home .nav ul li span{
    position: absolute;
    left: 0;
    bottom: -25px;
    text-align: center;
    width: 100%;
    font-weight: 100;
  }
  .home .banner .nav ul li:hover{
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 11px;
  }
  .home .banner .nav ul li.on {
    background:url("../assets/img/hover.png")no-repeat;
    color: #fffefe;
    background-position: 0 11px;
  }
  .home .banner .nav .btn{
    float: right;
    margin-right: 150px;
    width: 185px;
    cursor: pointer;
    margin-top: 30px;
    height: 62px;
    background: url("../assets/img/btn.png")no-repeat;
  }
  .home .title{
    text-align: center;
    margin: 0 auto;
    margin-top: 100px;
  }

  .home .content{
    width: 1200px;
    margin: 0 auto;
    margin-top: 30px;
    /*margin-bottom: 170px;*/
    padding-bottom: 23px;
    /*overflow: hidden;*/
  }
  .home .content .Chi_Eng{
    font-size: 16px;
    color: #949494;
    text-align: right;
    margin-bottom: 20px;
    margin-top: 40px;
  }
  .home .content .Chi_Eng span{
    cursor: pointer;
  }
  .home .content .Chi_Eng .on{
    color: #ffffff;
    font-size: 20px;
  }
  .home .content .mp1{
    width: 540px;
    height: 560px;
    float: left;
    padding: 0 60px;
    background-color: #2a2a2a;
    border-top-left-radius:20px;
    border-bottom-left-radius:20px;
  }
  .home .content .mp1 p{
    /*margin-left: 60px;*/
    font-size: 14px;
    color: #ffffff;
  }
  .home .content .mp1 .mp1_title{
    font-size: 20px;
    font-weight: 900;
    margin-bottom: 20px;
    color: #ffffff;
  }
  .home .content .mp1 .mp1_title img{
    margin-right: 15px;
    margin-top: 3px;
    float: left;
  }
  .home .content .mp2{
    width: 660px;
    float: right;
  }
  /*.home .content .map img{*/
    /*width: 100%;*/
  /*}*/
  /*.home .content .map p {*/
    /*color: #ffffff;*/
    /*margin: 10px 0;*/
  /*}*/
  .home .content .location{
    margin-top: 60px;
    width: 1200px;
    background-color: #2a2a2a;
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    height: 720px;
  }
  .home .content .location p{
    text-indent: 2em;
    color: #ffffff;
    font-size: 14px;
    margin-left: 20px;
  }
  .home .content .new{
    margin-bottom: 200px;
    overflow: hidden;
    background:none;
    margin-top: 60px;
  }
  .home .content .imgList{
    width: 600px;
    height: 340px;
    float: left;
  }
  .home .swiper-container {
    height: 340px;
  }
  .home .swiper-slide img{
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .home .swiper-pagination-bullet{
    width: 10px;
    height: 10px;
    background-color: #fff;
    opacity: 1;
  }
  .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    /*width: none;*/
    /*float: right;*/
    /*right: 0;*/
    /*width: 150px;*/
    /*left: none;*/
  }
  .home .swiper-pagination-bullet-active{
    border-radius: 10px;
    background: #db0e09;
    width: 10px;
    height: 10px;
  }
  .home .content .newsList{
    width: 570px;
    float: right;
  }
  .home .content .newsList ul li{
    background: url("../assets/img/newIcon.png")no-repeat;
    background-position-y: 22px;
  }
  .home .content .newsList ul li span{
    display: inline-block;
    width: 410px;
    height: 50px;
    color: #ffffff;
    /*font-weight: 900;*/
    font-size: 20px;
    overflow:hidden;
    line-height: 50px;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin-left: 30px;
    cursor: pointer;
  }
  .home .content .newsList ul li .timer{
    float: right;
    color: #949494;
    font-size: 16px;
    display: inline-block;
    width: 110px;
    margin-left: 0px;
  }
  .home .content .introduce{
    width: 1200px;
    margin: 0 auto;
    margin-top: 60px;
    /*margin-bottom: 200px;*/
  }
  .home .content .introduce .text{
    text-align: center;
    margin-top: 80px;
    margin-bottom: 100px;
    font-size: 20px;
    line-height: 50px;
    color: #ffffff;
  }
  .home .content .bonus{
    margin: 0 auto;
    margin-top: 60px;
    text-align: center;
    /*margin-bottom: 390px;*/
  }
  .home .content .coop{
    margin: 0 auto;
    text-align: center;
    /*width: 600px;*/
    margin-top: 80px;
  }
</style>
<template>
  <div class="home">
    <myhead></myhead>
    <div class="banner">
      <nav class="nav">
        <img src="../assets/img/logo.png" alt=""/>
        <ul>
          <li class="on" @click="urlFun('/home')"> 首页 <span>Home</span></li>
          <li @click="urlFun('/news')">新闻<span> News</span></li>
          <li @click="urlFun('/rules')">规则<span> Rule</span></li>
          <li @click="urlFun('/match')">赛程<span>Schedule</span></li>
          <!--<li @click="urlFun('/videoList')">视频<span>Video</span></li>-->
          <li @click="urlFun('/stadium')">场馆<span>Venue</span></li>
          <li @click="urlFun('/live')">直播<span> Live</span></li>
        </ul>
        <div class="btn" @click="urlFun('/signUp')"></div>
      </nav>
    </div>
    <div class="content">
      <div style="margin-top: -190px; width: 1200px;">
        <img src="../assets/img/matchImg.png" alt="" style="width: 1200px; margin: 0px auto; display: inherit;">
        <img  @click="urlFun('/signUp')" src="../assets/img/home1.png" style="width: 1200px; margin: 0px auto; display: inherit; cursor: pointer;">
        <div class="title"><img src="../assets/img/title1.png" alt=""/></div>
        <div style="overflow: hidden;">
          <p class="Chi_Eng"><span @click="mapClick(1)" :class="{on:map==1}">Chinese</span> / <span @click="mapClick(2)" :class="{on:map==2}">English</span></p>
          <div class="mp1">
            <div style="margin-top: 60px;padding-bottom: 55px;border-bottom: 1px solid #383838;">
              <p class="mp1_title"><img src="../assets/img/icon.png" alt=""/> 赛事地点</p>
              <p>上海市逸仙路1328号 新业坊·源创 6号楼</p>
              <p style="margin-top: 5px;color: #949494;">No. 1328, Yixian Road, Shanghai, Xinye Fang·Yuanchuang Global Scienceand Technology Demonstration Zone</p>
            </div>
            <div style="margin-top: 30px;">
              <p class="mp1_title"><img src="../assets/img/icon2.png" alt=""/>路线1</p>
              <p>上海虹桥国际机场 -> 地铁2号线 → 地铁3号线 ->场馆</p>
              <p style="margin-top: 5px;color: #949494;">Shanghai Hongqiao International Airport -> Metro Line 2 →Metro Line 3 -> Venue</p>
            </div>
            <div style="margin-top: 30px;">
              <p class="mp1_title"><img src="../assets/img/icon3.png" alt=""/>路线2</p>
              <p>上海浦东国际机场 -> 地铁2号线 → 地铁4号线 → 地铁3号线  -> 场馆</p>
              <p style="margin-top: 5px;color: #949494;">Shanghai Pudong International Airport -> Metro Line 2 →Metro Line 4 →  Metro Line 3 -> Venue</p>
            </div>
            <!--<img src="../assets/img/map1.png" alt=""/>-->
            <!--<p>比赛地点：上海市逸仙路1328号 新业坊·源创全球科创示范区</p>-->
            <!--<br/>-->
            <!--<p>线路1:上海虹桥国际机场 -> 地铁2号线 → 地铁3号线 ->场馆</p>-->
            <!--<br/>-->
            <!--<p>线路2:上海浦东国际机场 -> 地铁2号线 → 地铁4号线 → 地铁3号线  -> 场馆</p>-->
          </div>
          <div class="mp2">
            <iframe v-if="map==1" src="http://www.google.cn/maps/embed?pb=!1m18!1m12!1m3!1d3408.4625689012537!2d121.48284531565263!3d31.31859598143671!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b2724e8505a4e9%3A0x26fa00917fbd1e09!2z5LiK5rW35biC5a6d5bGx5Yy65LqU6KeS5Zy66YC45LuZ6LevMTMyOOWPtyDpgq7mlL_nvJbnoIE6IDIwMDA2NQ!5e0!3m2!1szh-CN!2scn!4v1566195582192!5m2!1szh-CN!2scn" width="660" height="560" frameborder="0" style="border:0" allowfullscreen></iframe>
            <iframe v-if="map==2" src="http://www.google.cn/maps/embed?pb=!1m18!1m12!1m3!1d3408.462568901253!2d121.48284531514557!3d31.318595981436744!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35b2724e8505a4e9%3A0x26fa00917fbd1e09!2s1328+Yixian+Rd%2C+Wu+Jiao+Chang%2C+Baoshan+Qu%2C+Shanghai+Shi%2C+200065!5e0!3m2!1sen!2scn!4v1566195693900!5m2!1sen!2scn" width="660" height="560" frameborder="0" style="border:0" allowfullscreen></iframe>
            <!--<p> No. 1328, Yixian Road, Shanghai, Xinye Fang·Yuanchuang Global Science and Technology Demonstration Zone</p>-->
            <!--<br/>-->
            <!--<p>Shanghai Hongqiao International Airport -> Metro Line 2 → Metro Line 3 -> Venue</p>-->
            <!--<br/>-->
            <!--<p>Shanghai Pudong International Airport -> Metro Line 2 →  Metro Line 4 →  Metro Line 3 -> Venue</p>-->
          </div>
        </div>
        <div class="title"><img src="../assets/img/title2.png" alt=""/></div>

          <div class="location">
            <img style="width: 1200px;margin:0 auto;display:block;" src="../assets/img/location.png" alt=""/>
            <br/>
            <p>酒店推荐：上海虹口大柏树亚朵酒店，地址：上海曲阳路1000号。距离活动场地约3公里，电话021-55979999全季酒店(上海新江湾城殷高路店) 上海市宝山区高境镇殷高路65号 (021)55895799</p>
            <br/>
            <p style="color: #949494;"> Recommended hotels：Atour Hotel (Shanghai Hongkou Dabaishu) reserve：400 862 8088 (CouponCode:74287) Business zone: Wujiaochang Business District (江湾/五角场商业区)Area: hongkouqu (虹口区)Address: QuYang road 1000, Hongkou District, Shanghai, China</p>
            <div>
              <img style="float: left;margin-right: 20px; margin-top: 25px; margin-left:60px;" src="../assets/img/buy.png" alt=""/>
              <br/>
              <br/>
              <p>订购链接： <a style="color: #ffffff;font-size: 12px" href="http://www.atourhotelhongkou.cn/en" target="_blank">http://www.atourhotelhongkou.cn/en</a></p>
              <p style="color: #949494;">Hotel Reservation ： <a style="color: #949494;font-size: 12px" href="http://www.atourhotelhongkou.cn/en" target="_blank">http://www.atourhotelhongkou.cn/en</a></p>
            </div>
          </div>
      </div>
      <div class="title"><img src="../assets/img/title3.png" alt=""/></div>
      <div class="new" v-if="newListData">
        <div class="imgList">
          <swiper :options="swiperOption"  ref="mySwiper" >
            <swiper-slide v-for="(key,index) in newListData" :key="index" >
              <img  :src="'http://admin.matchon.net/'+key.newsPic" alt="" @click="newFun(key.news_id)"/>
            </swiper-slide>

            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>
        </div>
        <div class="newsList">
          <ul>
            <li v-for="(key,index) in newListData" @click="newFun(key.news_id)"><span>{{key.newsTitle}}</span><span class="timer">{{key.createTime}}</span></li>
          </ul>
        </div>
      </div>
      <div class="title"><img src="../assets/img/title4.png" alt=""/></div>
      <div class="introduce">
        <img src="../assets/img/introduceimg.png" alt=""/>
        <div class="text">
          <img style="width: 100%" src="../assets/img/imgs1.png" alt=""/>
          <img style="width: 100%;    margin-top: -17px;" src="../assets/img/imgs2.png" alt=""/>
          <img style="width: 100%;    margin-top: -17px;" src="../assets/img/imgs3.png" alt=""/>
          <img style="width: 100%;    margin-top: -17px;" src="../assets/img/imgs4.png" alt=""/>
          <img style="width: 100%;    margin-top: -17px;" src="../assets/img/imgs5.png" alt=""/>
          <img style="width: 100%;    margin-top: -17px;" src="../assets/img/imgs6.png" alt=""/>
          <img style="width: 100%;    margin-top: -17px;" src="../assets/img/imgs7.png" alt=""/>
          <!--<img style="width: 100%" src="../assets/img/imgs8.png" alt=""/>-->
        </div>
      </div>
      <div class="title"><img src="../assets/img/title5.png" alt=""/></div>
      <div class="bonus"><img src="../assets/img/bonus.png" alt=""/></div>
      <div class="coop"><img src="../assets/img/coop_1.png" alt=""/></div>
      <div class="coop"><img src="../assets/img/coop_2.png" alt=""/></div>
    </div>
    <mybottom></mybottom>
  </div>
</template>

<script>
  import myhead from './Head.vue'
  import mybottom from './Bottom.vue'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'
  export default {
    name: 'Home',
    components: {
      swiper,
      swiperSlide,
      myhead,
      mybottom
    },
    data () {
      return {
        map:1,
        newListData:"",
//      轮播图
        swiperOption: {
          autoplay:{
            enabled: true,
            disableOnInteraction: false,
            delay: 3000,
          },
          notNextTick:true,
          pagination:'.swiper-pagination',
          slidesPerView:'auto',
          centeredSlides:true,
          paginationClickable:true,
//          spaceBetween:30,
          slideShadows:true,
          onSlideChangeEnd:swiper=>{
//            this.page=swiper.realIndex+1;
          },
          pagination:{
            el:".swiper-pagination"
          },
        },
      }
    },

    computed:{

    },
    mounted(){
      this.newListDataFun();
    },
    methods:{
      newFun(id){
        this.$router.push({path: '/newDetails', query: {nid: id}})
      },
      urlFun(url){
//        this.$router.push({path:`/new/${id}`})
        this.$router.push({path:url})
      },
      newListDataFun(){
        let _this=this;
        let formd=new FormData()
        formd.append("seriesId",30)
        formd.append("rowNum",6)
        formd.append("matchId",139)
        this.$axios.post("http://admin.matchon.net/client/getNewsList",formd).then((data) => {
          _this.newListData=data.data.data
        });
      },
      mapClick(map){
        this.map=map;
      },
    },
    filters:{

    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Home.vue